module.exports = __webpack_public_path__ + "static/img/Adult-Human-Torso-A01-X-Ray5.35fd09cc.jpg";